//import { userConstants } from '../_constants';

export function scenario(state = {}, action) {
  console.log('scenario reducer');
  switch (action.type) {
    case 'SCENARIO_APPLY_REQUEST':
      console.log('applying to state');
      return {
        selectedScenario: action.scenarioId
      };
    case 'SCENARIO_REMOVE_REQUEST':
      return {
        selectedScenario: ''
      };
    default:
      console.log('default state');
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/scenario.reducer.js